export default {
  getTemplateById(state) {
    return (template_id) => {
      let template = state.available_templates.find((template) => {
        return template.id == template_id;
      });
      return template;
    };
  },

  getTemplate(state) {
    return state.template;
  },

  getThemeById(state) {
    return (theme_id) => {
      if (state.available_themes) {
        return state.available_themes.find((theme) => {
          return theme.id === theme_id;
        });
      }
    }
  },
  
  getCampaignId(state) {
    return state.campaign_id;
  },

  getCampaign(state) {
    return state.campaign;
  },

  getTemplateImages(state) {
    return state.templateImages;
  },

  getTemplateColors(state) {
    return state.templateColors;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/store/selector/getters.js